import swal2 from "sweetalert2";

const CONFIRMATION_TEXT_STYLE = "color: #000000DE; font-family: satoshi, sans-serif; font-size: 15; font-weight: 400;";

const askSkipValidation = (skipValidationInfo) =>
    swal2.fire({
        title: skipValidationInfo.title,
        html: `
                <p style="${CONFIRMATION_TEXT_STYLE}">
                    ${skipValidationInfo.message}
                </p>
            `,
        icon: 'warning',
        confirmButtonText: skipValidationInfo.confirmationButton || 'Confirmar',
        cancelButtonText: skipValidationInfo.cancelButtonText || 'Cancelar',
        showCancelButton: true,
        ...(skipValidationInfo.alternativeKey ? {
            showDenyButton: true,
            denyButtonText: skipValidationInfo.alternativeButton,
        } : {}),
    });

export const confirmSkipValidation = (skipValidationInfo) =>
    askSkipValidation(skipValidationInfo).then(result => !!result.isConfirmed);

export const chooseSkipValidationParams = (skipValidationInfo) =>
    askSkipValidation(skipValidationInfo).then(result => {
        if (result.isConfirmed) return { [skipValidationInfo.key]: true };
        if (result.isDenied && skipValidationInfo.alternativeKey)
            return { [skipValidationInfo.alternativeKey]: true };
        return null;
    });
